import { render, staticRenderFns } from "./Credenciales.vue?vue&type=template&id=8db36c6a&lang=pug&"
import script from "./Credenciales.vue?vue&type=script&lang=js&"
export * from "./Credenciales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports